import { Box, HStack, VStack, Text, Icon } from '@chakra-ui/react';
import { MdDashboard, MdList, MdShowChart, MdSettings } from 'react-icons/md';

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 0, label: 'DASHBOARD', icon: MdDashboard },
    { id: 1, label: 'SCHEDULE', icon: MdList },
    { id: 2, label: 'REPORTS', icon: MdShowChart },
    { id: 3, label: 'SETTINGS', icon: MdSettings },
  ];

  return (
    <Box 
      position="fixed" 
      bottom={0} 
      left={0} 
      right={0} 
      bg="bottomNav.bg" 
      borderTop="1px solid" 
      borderColor="card.border"
      zIndex={100}
      pb="env(safe-area-inset-bottom)"
      boxShadow="0 -4px 12px rgba(0,0,0,0.1)"
    >
      <HStack justify="space-around" p={2}>
        {tabs.map((tab) => (
          <VStack 
            key={tab.id}
            as="button"
            onClick={() => onTabChange(tab.id)}
            spacing={1}
            color={activeTab === tab.id ? "white" : "whiteAlpha.600"}
            flex={1}
            py={2}
            bg={activeTab === tab.id ? "brand.blue" : "transparent"}
            transition="0.2s"
          >
            <Icon as={tab.icon} boxSize={6} />
            <Text fontSize="10px" fontWeight="bold">{tab.label}</Text>
          </VStack>
        ))}
      </HStack>
    </Box>
  );
};

export default BottomNav;
